export interface Props {
  color: string;
  hoverColor: string;
}

const Linkedin = ({ color, hoverColor }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      className={`size-5 lg:size-6 ${color} duration-300 ease-in-out fill-current hover:text-${hoverColor}`}
      fill="none"
    >
      <path
        fill=""
        d="M6.94 5a2 2 0 1 1-4-.002 2 2 0 0 1 4 .002ZM7 8.48H3V21h4V8.48Zm6.32 0H9.34V21h3.94v-6.57c0-3.66 4.77-4 4.77 0V21H22v-7.93c0-6.17-7.06-5.94-8.72-2.91l.04-1.68Z"
      />
    </svg>
  );
};

export default Linkedin;
